import * as React from "react";
import {
  AppBar,
  Box,
  Button,
  Divider,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  MenuItem,
  Menu,
  Toolbar,Stack
} from "@mui/material";

import MenuIcon from "@mui/icons-material/Menu";
import tatastrivewhite from "../assets/images/TataSTRIVE-white.png";
import tatastrive from "../assets/images/TataSTRIVE.png";
import fsslogo from "../assets/images/FSS_Logo1.png";
import { NavLink } from "react-router-dom";
import { Logout } from "@mui/icons-material";
import { useUserContext } from "../context/UserContext";

const drawerWidth = 240;

// Dynamic Navigation Configuration
const pages = [
  { path: "/dashboard", label: "Dashboard" },
  { path: "/schedule", label: "Schedule" },
  { path: "/support", label: "FSS Support" },
  {
    label: "Admin",
    isAdminRequired: true,
    children: [
      { path: "/facilitator-management", label: "Facilitator's Management" },
      { path: "/fsc-management", label: "FSC's Management" },
    ],
  },
];

const striveImg = (
  <img
    src={tatastrivewhite}
    alt="logo"
    style={{
      maxHeight: "35px",
      margin: "auto",
    }}
  />
);

const fssImg = (
  <img
    src={fsslogo}
    alt="logo"
    style={{
      height: "40px",
    }}
  />
);

function DrawerAppBar(props) {
  const { window } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);

  const { logout, user } = useUserContext();

  const handleAdminMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDrawerToggle = () => {
    setMobileOpen((prevState) => !prevState);
  };

  const container =
    window !== undefined ? () => window().document.body : undefined;

  return (
    <>
      <AppBar component="nav" color="primary">
        <Toolbar sx={{ display: "flex", alignItems: "center" }}>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2, display: { md: "none" } }}
          >
            <MenuIcon />
          </IconButton>

          <Box sx={{ display: "block", flexGrow: 1 }}>{fssImg}</Box>

          {/* Desktop Navigation Links */}
          <Box
            sx={{
              display: { xs: "none", md: "flex" },
              alignItems: "center",
              gap: 1,
              flexGrow: 1,
            }}
          >
            {pages.map((page) => {
              // Rule 1: Admin option ki permission validation
              if (page.isAdminRequired && !user?.isAdmin) {
                return null;
              }

              // Rule 2: Sub-items/Children unte Menu Dropdown render authundhi
              if (page.children) {
                return (
                  <React.Fragment key={page.label}>
                    <Button color="inherit" onClick={handleAdminMenu}
                    sx={{
    textTransform: "none",
    fontSize: "1rem",      
    fontWeight: 500,      
    padding: "6px 8px",   
  }}
                    >
                      {page.label}
                    </Button>
                    <Menu
                      anchorEl={anchorEl}
                      open={Boolean(anchorEl)}
                      onClose={handleClose}
                    >
                      {page.children.map((child) => (
                        <MenuItem
                          key={child.path}
                          component={NavLink}
                          to={child.path}
                          onClick={handleClose}
                        >
                          {child.label}
                        </MenuItem>
                      ))}
                    </Menu>
                  </React.Fragment>
                );
              }

              // Rule 3: Normal direct NavLink render authundhi
              return (
                <NavLink
                  key={page.path}
                  to={page.path}
                  className={({ isActive }) =>
                    isActive ? "navbar active-menu" : "navbar"
                  }
                >
                  {page.label}
                </NavLink>
              );
            })}

            <NavLink
              onClick={logout}
              to="/"
              className={({ isActive }) =>
                isActive ? "navbar active-menu" : "navbar"
              }
            >
              Logout
            </NavLink>
          </Box>

          <Box sx={{ display: { xs: "none", sm: "block" } }}>
            {striveImg}
          </Box>
        </Toolbar>
      </AppBar>

      {/* Mobile Drawer */}
      <Box component="nav">
        <Drawer
          container={container}
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true,
          }}
          sx={{
            display: { sm: "block", md: "none" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
            },
          }}
        >
          <Stack
            height="100vh"
            justifyContent="space-between"
            onClick={handleDrawerToggle}
            sx={{ textAlign: "center" }}
          >
            <div>
              <Toolbar>
                <img
                  src={tatastrive}
                  alt="logo"
                  style={{
                    maxHeight: "40px",
                    margin: "auto",
                  }}
                />
              </Toolbar>

              <Divider />

              <List>
                {pages.map((page) => {
                  if (page.isAdminRequired && !user?.isAdmin) {
                    return null;
                  }

                  if (page.children) {
                    return page.children.map((child) => (
                      <NavLink
                        to={child.path}
                        key={child.path}
                        className={({ isActive }) =>
                          isActive ? "active-drawer" : "inactive-drawer"
                        }
                      >
                        <ListItem disablePadding>
                          <ListItemButton sx={{ textAlign: "center" }}>
                            <ListItemText primary={child.label} />
                          </ListItemButton>
                        </ListItem>
                      </NavLink>
                    ));
                  }

                  return (
                    <NavLink
                      to={page.path}
                      key={page.path}
                      className={({ isActive }) =>
                        isActive ? "active-drawer" : "inactive-drawer"
                      }
                    >
                      <ListItem disablePadding>
                        <ListItemButton sx={{ textAlign: "center" }}>
                          <ListItemText primary={page.label} />
                        </ListItemButton>
                      </ListItem>
                    </NavLink>
                  );
                })}
              </List>

              <Divider />
            </div>

            <Button
              onClick={logout}
              variant="contained"
              startIcon={<Logout />}
              sx={{ my: 4, mx: 2 }}
            >
              Logout
            </Button>
          </Stack>
        </Drawer>
      </Box>
    </>
  );
}

export default DrawerAppBar;
